import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MaintenancePlanModalComponent } from '@app/maintenance/components/maintenance-plan-modal/maintenance-plan-modal.component';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import * as MaintenanceReducer from "@app/maintenance/store/maintenance.reducer"
import { AddPlanAction, LoadPlansAction } from '@app/maintenance/store/maintenance.actions';
import { Subscription } from 'rxjs/Subscription';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from "rxjs/operators";
import * as _ from "lodash";

@Component({
    selector: 'app-tool-maintenance-plans',
    templateUrl: './tool-maintenance-plans.component.html',
    styleUrls: ['./tool-maintenance-plans.component.scss']
})
export class ToolMaintenancePlansComponent implements OnInit, OnDestroy {
    @ViewChild(MaintenancePlanModalComponent) modal: MaintenancePlanModalComponent;

    toBeCreatedDocuments;
    plans = [];
    tableConfig = new TableConfig();

    loading$: Observable<any>;
    loadingPlans$: Observable<any>;
    plans$: Observable<any>;
    createdPlan$: Observable<any>;

    plansSubscription: Subscription;

    constructor(private store: Store<any>, private router: Router, private route: ActivatedRoute) {
        this.loading$ = this.store.pipe(select(MaintenanceReducer.isLoading), map(loading => _.cloneDeep(loading)));
        this.loadingPlans$ = this.store.pipe(select(MaintenanceReducer.isLoadingPlans), map(loading => _.cloneDeep(loading)));
        this.plans$ = this.store.pipe(select(MaintenanceReducer.getPlans), map(plans => _.cloneDeep(plans)));
        this.createdPlan$ = this.store.pipe(select(MaintenanceReducer.getCreatedPlan), map(plan => _.cloneDeep(plan)));

        this.plansSubscription = this.plans$.subscribe(plans => {
            if (plans) {
                this.plans = plans.items;
                // @ts-ignore
                this.tableConfig = {
                    ...this.tableConfig,
                    pager: {
                        ...this.tableConfig.pager,
                        count: plans.total // modify count property
                    }
                };
            }
        });
    }

    ngOnInit() {
        this.store.dispatch(new LoadPlansAction(this.tableConfig));
    }

    getAll() {
        this.store.dispatch(new LoadPlansAction(this.tableConfig));
    }

    openModal() {
        this.modal.open();
    }

    onSubmit(event: any) {
        const eventClone = _.cloneDeep(event);
        if (eventClone.documents) {
            this.toBeCreatedDocuments = eventClone.documents;
        }
        this.store.dispatch(new AddPlanAction(eventClone));
    }

    onSortChange() {
        this.getAll();
    }

    onPageChange() {
        this.getAll();
    }

    onFilter() {
        this.getAll();
    }

    onSelectPlan(event: any) {
        this.router.navigate([`${event.id}/details`], {relativeTo: this.route});
    }

    onOpenNewPage(plan: any) {
        const link = `tool-maintenance-plans/plans/${plan.id}/details`;
        localStorage.setItem('openedInNewTab', 'true');
        window.open(link);
    }

    ngOnDestroy(): void {
        if (this.plansSubscription) {
            this.plansSubscription.unsubscribe();
        }
    }
}
